// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Zddz","right":"styles_right__2QXf8"};